import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GetTickets {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  AllTicketsData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: GetTickets = {
  isLoading: false,
  error: false,
  message: null,
  AllTicketsData: [],
  Items: [],
  Pagination: [],
};

const GetTicketsSlice = createSlice({
  name: "tickets",
  initialState,
  reducers: {
    loadingTickets: (state: GetTickets, action: PayloadAction<{}>) => {
      state.isLoading = true;
    },
    setTickets: (state: any, action: PayloadAction<GetTickets>) => {
      return action.payload;
    },
    clearData: (state: GetTickets, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const { loadingTickets, setTickets, clearData } =
  GetTicketsSlice.actions;

export default GetTicketsSlice.reducer;
